import "core-js/modules/es.array.fill.js";
export var checkboxSwitchPortalTokens = {
  paddingY: {
    s: 7,
    m: 8,
    l: 10
  },
  labelColor: function labelColor(_ref) {
    var color = _ref.color;
    return color.text.black.base;
  },
  labelColorDisabled: function labelColorDisabled(_ref2) {
    var color = _ref2.color;
    return color.text.black.base;
  },
  focusBoxShadowAttrs: "0 0 3px 1px",
  border: {
    invalidWidth: 2,
    color: {
      invalidBase: function invalidBase(_ref3) {
        var color = _ref3.color;
        return color.border.input.invalid.base;
      },
      invalidHover: function invalidHover(_ref4) {
        var color = _ref4.color;
        return color.border.input.invalid.hover;
      }
    }
  },
  tumblerWrapper: {
    sizes: {
      s: {
        x: 32,
        y: 18
      },
      m: {
        x: 43,
        y: 24
      },
      l: {
        x: 50,
        y: 28
      }
    },
    radius: "25px",
    color: {
      base: function base(_ref5) {
        var color = _ref5.color;
        return color.border.input.base;
      },
      baseHover: function baseHover(_ref6) {
        var color = _ref6.color;
        return color.border.input.hover;
      },
      baseDisabled: function baseDisabled(_ref7) {
        var color = _ref7.color;
        return color.border.input.base;
      },
      checked: function checked(_ref8) {
        var color = _ref8.color;
        return color.importance.primary.base;
      },
      checkedHover: function checkedHover(_ref9) {
        var color = _ref9.color;
        return color.importance.primary.hover;
      },
      checkedDisabled: function checkedDisabled(_ref10) {
        var color = _ref10.color;
        return color.importance.primary.base;
      },
      toggleDisabled: function toggleDisabled(_ref11) {
        var color = _ref11.color;
        return color.fill.item.base;
      },
      invalidBase: function invalidBase(_ref12) {
        var color = _ref12.color;
        return color.border.input.invalid.base;
      },
      invalidHover: function invalidHover(_ref13) {
        var color = _ref13.color;
        return color.border.input.invalid.hover;
      },
      focusBase: function focusBase(_ref14) {
        var color = _ref14.color;
        return color.border.focus.base;
      },
      focusHover: function focusHover(_ref15) {
        var color = _ref15.color;
        return color.border.focus.hover;
      },
      focusInvalid: function focusInvalid(_ref16) {
        var color = _ref16.color;
        return color.border.focus.invalid.base;
      },
      focusInvalidHover: function focusInvalidHover(_ref17) {
        var color = _ref17.color;
        return color.border.focus.invalid.hover;
      },
      borderColorBase: function borderColorBase(_ref18) {
        var color = _ref18.color;
        return color.fill.item.base;
      }
    },
    gapToLabel: {
      s: 6,
      m: 6,
      l: 8
    }
  },
  tumbler: {
    sizes: {
      s: 14,
      m: 20,
      l: 24
    },
    radius: "50%",
    color: {
      base: function base(_ref19) {
        var color = _ref19.color;
        return color.fill.item.base;
      },
      hover: function hover(_ref20) {
        var color = _ref20.color;
        return color.fill.item.base;
      },
      disabled: function disabled(_ref21) {
        var color = _ref21.color;
        return color.fill.item.base;
      }
    }
  },
  opacityOnDisable: 0.5
};